import type { ReactNode } from 'react'
import * as React from 'react'
import Sheet from 'components/utils/Sheet'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import Divider from 'LuxKit/Divider'
import CartPanelItemDispatcher from './CartPanelItemDispatcher'
import type { CartPanelExperienceItem, CartPanelItem } from '../hooks/useCartPanelItems'

interface Props {
  title: string
  icon: ReactNode
  items: Array<CartPanelItem>
  onToggleInclude: (item: CartPanelItem) => void
  onChangeRoom: (item: CartPanelItem) => void
  onSetDates: () => void
  onAdjustDays: (item: CartPanelItem) => void
  onChooseTickets: (item: CartPanelExperienceItem) => void
  onChooseDate: (item: CartPanelExperienceItem) => void
  onChooseTime: (item: CartPanelExperienceItem) => void
  onChooseDifferentTickets: (item: CartPanelExperienceItem) => void
  onDelete: (item: CartPanelItem) => void
  isStreaming: boolean
}

function CartPanelSection({
  title,
  icon,
  items,
  onToggleInclude,
  onChangeRoom,
  onSetDates,
  onAdjustDays,
  onChooseTickets,
  onChooseDate,
  onChooseTime,
  onChooseDifferentTickets,
  onDelete,
  isStreaming,
}: Props) {
  return (
    <div>
      <Sheet padding="16 16 8">
        <HeadingTextBlock startIcon={icon} variant="heading5">{title}</HeadingTextBlock>
      </Sheet>
      {items.map((item, index) => (
        <React.Fragment key={item.key}>
          {index > 0 && <Divider kind="primary" />}
          <CartPanelItemDispatcher
            item={item}
            onToggleInclude={onToggleInclude}
            onChangeRoom={onChangeRoom}
            onSetDates={onSetDates}
            onAdjustDays={onAdjustDays}
            onChooseTickets={onChooseTickets}
            onChooseDate={onChooseDate}
            onChooseTime={onChooseTime}
            onChooseDifferentTickets={onChooseDifferentTickets}
            onDelete={onDelete}
            isStreaming={isStreaming}
          />
        </React.Fragment>
      ))}
    </div>
  )
}

export default CartPanelSection
